import { useRef, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import TopBar from "./TopBar";
import { useStateDistrict, useConsignmentTypes, useShippingModes } from "../../utils/Utilities.js";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom
import { useNavigate } from 'react-router-dom'; // Import useNavigate
const UPDATE_FRANCHISE_RATE_URL = "api/admin/update-franchise-rate";


const UpdateFranchiseRate = () => {
    const { rateId } = useParams(); // Get the rateId from the URL
    const navigate = useNavigate();
    const GET_Rate_URL = `api/admin/get-franchise-rate?rate_id=${rateId}`;
    const axiosPrivate = useAxiosPrivate();

    const [rateDetails, setRateDetails] = useState(null);  // To store fetched rate data
    const [error, setError] = useState(null);    // To handle errors

    const [franchise_name, Setfranchise_name] = useState("");
    useEffect(() => {
        const fetchData = async () => {
            const headers = {
                'Content-Type': 'application/json',
            };

            try {
                const response = await axiosPrivate.get(GET_Rate_URL, {
                    headers,
                    withCredentials: true, // Ensures cookies are sent with the request if needed
                });
                setRateDetails(response.data); // Store the fetched data into the setRateDetails state
                // console.log("response:", JSON.stringify(response.data, null, 2));
                Setfranchise_name(response.data.franchise_name)
                Setfranchise_name(response.data.franchise_name)
                setStateId(response.data.state_id)
                setDistrict(response.data.district_id)
                setShippingMode(response.data.shipping_mode)
                setConsignmentType(response.data.consignment_type)
                // setMinimumWeight(response.data.min_weight)
                setMaximumWeight(response.data.max_weight)
                setRate(response.data.rate)
                setAb_cost(response.data.ab_cost)
                setSurchargePerc(response.data.surcharge_perc)
                setLoading(false); // Stop loading spinner
            } catch (error) {
                console.error("Error fetching data:", error);
                setError("Failed to load data");
                setLoading(false);  // Set loading to false even if there is an error
            }
        };

        fetchData();
    }, [rateId]);  // Add rateId as a dependency to re-fetch data if rateId changes


    const [showValidation, setShowValidation] = useState(false);
    const {
        statesList,
        districtsList,
        stateId,
        setStateId,
        district,
        setDistrict,
        loadingStates,
        loadingDistricts,
    } = useStateDistrict();


    const back = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setFranchiseId("");
    };


    const userRef = useRef();
    const errRef = useRef();
    const { auth } = useAuth();


    // const [role, setRole] = useState("");
    const [franchiseId, setFranchiseId] = useState("");

    const [errMsg, setErrMsg] = useState("");
    const [success, setSuccess] = useState(false);

    const [selectedFranchise, setSelectedFranchise] = useState(null);
    const [franchiseDbId, setFranchiseDbId] = useState('');
    const [franchiseList, setFranchiseList] = useState([]);
    const [filteredFranchises, setFilteredFranchises] = useState([]);

    const LIST_FRANCHISE_URL = "api/list-franchises";
    const [loading, setLoading] = useState(true);


    // Handle selection from dropdown
    const handleSelect = (franchise) => {
        setFranchiseId(franchise.franchise_name);
        setFranchiseDbId(franchise.franchise_id);
        setSelectedFranchise(franchise);
        setFilteredFranchises([]);
    };

    const handleInputChange = (e) => {
        const input = e.target.value;
        setFranchiseId(input);
        setSelectedFranchise(null);
        setFranchiseDbId('');

        const filtered = franchiseList.filter((item) =>
            item.franchise_name.toLowerCase().includes(input.toLowerCase())
        );
        setFilteredFranchises(filtered);
    };


    useEffect(() => {
        const fetchFranchises = async () => {
            try {
                const token = localStorage.getItem('token'); // or get from context/state
                // console.log('Auth token being used:', token);

                const response = await axiosPrivate.get(LIST_FRANCHISE_URL, {
                    withCredentials: true,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                setFranchiseList(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Failed to fetch franchises:', error);
            }
        };

        fetchFranchises();
    }, []);


    const [consignmentType, setConsignmentType] = useState("");
    const [shippingMode, setShippingMode] = useState("");


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                rate_id: rateId,
                shipping_mode: shippingMode,
                consignment_type: consignmentType,
                // min_weight: Number(minimumWeight),
                max_weight: Number(maximumWeight),
                rate: Number(rate),
                ab_cost: Number(ab_cost),
                surcharge_perc: Number(surchargePerc),
                state_id: Number(stateId)
            };

            // Optional fields
            const optionalFields = {
                district_id: district,
            };


            Object.entries(optionalFields).forEach(([key, value]) => {
                if (value !== "" && value !== null && value !== undefined) {
                    payload[key] = Number.isNaN(Number(value)) ? value : Number(value);
                }
            });
            // console.log("payload:", JSON.stringify(payload, null, 2));
            await axiosPrivate.post(UPDATE_FRANCHISE_RATE_URL, payload, {
                headers: { "Content-Type": "application/json" },
                withCredentials: true,
            });

            alert("Franchise rate created successfully");

        } catch (err) {
            let message = "";

            if (!err?.response) {
                message = "No Server Response";
            } else if (err.response?.status === 409) {
                message = err.response?.data.message;
            } else {
                message = "Failed!\n" + err.response?.data.message;
            }

            setErrMsg(message);

            // Clear error message after 5 seconds
            setTimeout(() => {
                setErrMsg("");
            }, 5000);
        }

    };





    const { consignmentTypes } = useConsignmentTypes();
    const { shippingModes } = useShippingModes();



    // const [minimumWeight, setMinimumWeight] = useState("");
    const [maximumWeight, setMaximumWeight] = useState("");
    const [rate, setRate] = useState("");
    const [ab_cost, setAb_cost] = useState("");
    const [surchargePerc, setSurchargePerc] = useState("");

    return (
        <>
            <Container>

                <section className="userregbody">
                    <p
                        ref={errRef}
                        className={errMsg ? "errmsg" : "offscreen"}
                        aria-live="assertive"

                    >
                        {errMsg}
                    </p>

                    <div className=" wrapperemp2">
                        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
                        <form onSubmit={handleSubmit}> {/* Add onSubmit handler to trigger login */}

                            <h3>Edit franchise rate</h3>
                            <Row>
                                <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="Username">Franchise Name
                                            <sup>*</sup></label>
                                        <input
                                            type="text"
                                            id="franchise-name"
                                            autoComplete="off"
                                            placeholder="Search Franchise Name"

                                            onChange={handleInputChange}
                                            value={franchise_name}
                                            style={{
                                                ...styles.input,
                                                backgroundColor: "#f2f2f2",
                                                color: "#888",
                                                cursor: "not-allowed"
                                            }}

                                            aria-describedby="usernamenote"
                                            disabled

                                        />
                                        {/* <i className="bx bxs-lock-alt"></i> */}
                                        {franchiseId && filteredFranchises.length > 0 && (
                                            <ul style={styles.dropdown}>
                                                {filteredFranchises.map((franchise) => (
                                                    <li
                                                        key={franchise.franchise_id}
                                                        style={styles.dropdownItem}
                                                        onMouseDown={() => handleSelect(franchise)}
                                                    >
                                                        {franchise.franchise_name} ({franchise.franchise_code})
                                                    </li>
                                                ))}
                                            </ul>
                                        )}

                                    </div>
                                </Col>
                                <Col>

                                    <div className="input-boxs">
                                        <label>State
                                            <sup>*</sup></label>

                                        <select
                                            className="newregselect"
                                            value={stateId}
                                            onChange={(e) => setStateId(e.target.value)}
                                            required
                                        >
                                            <option value="">Select State</option>

                                            {statesList.map((state) => (
                                                <option key={state.state_id} value={state.state_id}>
                                                    {state.state_name} - ({state.state_code})
                                                </option>
                                            ))}
                                        </select>

                                        {showValidation && !stateId && (
                                            <div className="mt-1 reqstyl">*State is required</div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            <Row>

                                <Col>

                                    <div className="input-boxs">
                                        <label>District</label>

                                        <select
                                            className="newregselect"
                                            value={district}
                                            onChange={(e) => setDistrict(e.target.value)}
                                            disabled={!stateId}
                                        >
                                            <option value="">Select District</option>

                                            {districtsList.map((dist) => (
                                                <option key={dist.district_id} value={dist.district_id}>
                                                    {dist.district_name} - ({dist.district_code})
                                                </option>
                                            ))}
                                        </select>

                                        {showValidation && !district && (
                                            <div className="mt-1 reqstyl">*District is required</div>
                                        )}
                                    </div>
                                </Col>
                                <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="Username">Shipping Mode
                                            <sup>*</sup></label>
                                        <select
                                            className="form-control"
                                            value={shippingMode}
                                            onChange={(e) => setShippingMode(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Shipping Mode</option>

                                            {shippingModes.map((mode) => (
                                                <option key={mode.shipping_mode} value={mode.shipping_mode}>
                                                    {mode.description}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>

                                    <div className=" input-boxs">
                                        <label htmlFor="password">Consignment Type
                                            <sup>*</sup></label>
                                        <select
                                            className="form-control"
                                            value={consignmentType}
                                            onChange={(e) => setConsignmentType(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Consignment Type</option>

                                            {consignmentTypes.map((item) => (
                                                <option
                                                    key={item.consignment_type}
                                                    value={item.consignment_type}
                                                >
                                                    {item.description}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                                {/* <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="confirm_pwd">Minimum Weight
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="minimumWeight"
                                            value={minimumWeight}
                                            min="0"
                                            step="1"
                                            onChange={(e) => setMinimumWeight(e.target.value)}
                                            required
                                        // placeholder="Minimum Weight"
                                        />

                                    </div>
                                </Col> */}

                                <Col>

                                    <div className="input-boxs">
                                        <label htmlFor="confirm_pwd">
                                            Maximum Weight
                                            <sup>*</sup>
                                        </label>

                                        <div className="weight-input-wrapper">
                                            <input
                                                type="number"
                                                name="maximumWeight"
                                                value={maximumWeight}
                                                min="0"
                                                step="0.001"
                                                onChange={(e) => setMaximumWeight(e.target.value)}
                                                required
                                            />
                                            <span>kg</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className=" input-boxs">
                                        <label>Rate
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="rate"
                                            value={rate}
                                            min="0"
                                            step="1"
                                            onChange={(e) => setRate(e.target.value)}
                                            required
                                        />
                                    </div>
                                </Col>

                                <Col>
                                    <div className=" input-boxs">
                                        <label >ab cost
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="ab_cost"
                                            value={ab_cost}
                                            min="0"
                                            step="1"
                                            onChange={(e) => setAb_cost(e.target.value)}
                                            required
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className=" input-boxs">
                                        <label >Surcharge %
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="surchargePerc"
                                            value={surchargePerc}
                                            min="0"
                                            step="1"
                                            onChange={(e) => setSurchargePerc(e.target.value)}
                                            required
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <center>
                                <button type="submit" className="btn regbutton">Submit</button>
                            </center>
                        </form>
                    </div>
                </section>

                <TopBar />
            </Container>
        </>
    );
};

const styles = {
    container: {
        padding: '40px',
        maxWidth: '500px',
        margin: 'auto',
        fontFamily: 'Arial, sans-serif',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
    inputWrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    input: {
        padding: '10px',
        fontSize: '16px',
        border: '1px solid #ccc',
        borderRadius: '4px',
    },
    dropdown: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderTop: 'none',
        maxHeight: '200px',
        overflowY: 'auto',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
    },
    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee',
    },
    button: {
        padding: '10px 15px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        fontSize: '16px',
        cursor: 'pointer',
    },


};

export default UpdateFranchiseRate;
